import { render } from "./CreateProjectType.vue?vue&type=template&id=e26ee0d8"
import script from "./CreateProjectType.vue?vue&type=script&lang=js"
export * from "./CreateProjectType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__